// extracted by mini-css-extract-plugin
export default {"box":"input-file_box__dcK53","inputfile-1":"input-file_inputfile-1__gBEEH","has-focus":"input-file_has-focus__aYiHQ","inputfile":"input-file_inputfile__6rihu"};